import { Input, Modal, Space } from '@yimoka/antd';
import { observer } from '@yimoka/react';
import { useEffect, useState } from 'react';

import { useTranslation } from '@/locales/i18n';

import { ImageCaptcha } from './captcha-image';

export interface PasswordLoginCaptchaProps {
  onCaptchaComplete?: (captchaID: string, captchaCode: string) => void;
  show?: boolean;
  onClose?: () => void;
}

export const PasswordLoginCaptcha = observer((props: PasswordLoginCaptchaProps) => {
  const { t } = useTranslation();
  const { onCaptchaComplete, show = false, onClose } = props;
  const [captchaID, setCaptchaID] = useState('');
  const [captchaCode, setCaptchaCode] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (!show) return;
    setCaptchaCode('');
    setRefreshKey(key => key + 1);
  }, [show]);

  const handleSubmit = () => {
    if (captchaCode.length !== 4) return;
    onCaptchaComplete?.(captchaID, captchaCode);
    setCaptchaCode('');
  };

  const handleCancel = () => {
    setCaptchaCode('');
    onClose?.();
  };

  return (
    <Modal
      mask={{ closable: false }}
      okButtonProps={{ disabled: captchaCode.length < 4 }}
      open={show}
      title={t('Account:captcha.imageTitle')}
      trigger={false}
      width={300}
      onCancel={handleCancel}
      onOk={handleSubmit}
    >
      <Space>
        <Input
          maxLength={4}
          placeholder={t('Account:captcha.imagePlaceholder')}
          style={{ width: 150 }}
          value={captchaCode}
          onChange={setCaptchaCode}
          onPressEnter={() => captchaCode.length === 4 && handleSubmit()}
        />
        <ImageCaptcha key={refreshKey} onChange={setCaptchaID} />
      </Space>
    </Modal>
  );
});
